import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
	Row,
	Col,
	Skeleton,
	Card,
	Tooltip,
	Space,
	DatePicker,
	Button,
	List,
	Avatar,
	Progress,
	Flex,
	Tag,
	Dropdown,
	Badge,
	Radio,
	Segmented,
	Divider,
	Grid,
} from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import DashboardJson from '../../json/Reclaim.json';
import LoaderJson from '../../json/loader.json';
import HeaderFile from '../../components/Header/HeaderFile';
// import { XThemeContainer } from '../../styles/GlobalThemeStyle';
import {
	XThemeContainer,
	XTheme2MainTitle,
	XTheme2Button,
	XTheme2AITag,
	XTheme2VATag,
	XTheme2Form,
} from '../../styles/GlobalThemeStyleCQ';
import AIInput from '../../components/ui/ai-input';
import { Counter } from '../../components/ui/counter';
import {
	XThemeButton,
	XThemeCardFancy,
	XThemeGradientFilterBtn,
	XThemeRadio,
	XThemeSelect,
	XThemeMobileDashboard,
	XThemeDrawer,
	XThemeFilterButton,
	XThemeFilterCircleButton,
	XThemeForm,
	XThemeMobileTableCard,
	XThemeMobileScrollCard,
} from '../../styles/GlobalThemeStyle';
import {
	XThemeReactSpeedometer,
	XThemeModalAnimation,
	XThemeCardTitle1,
	XThemeCardTitle2,
	XThemeCaseCard,
	XThemeCardTitle3,
	XThemeStatisticsCard,
	XThemeStatisticsGraphCard,
	XThemeReimbursementCard,
	XThemePayersCard,
	XThemeSwitch,
	XThemeTableCharts,
	XThemeLottie,
	XThemeLottieLoader,
	XThemeCreateCaseBtn,
} from './DashboardStyle';
import CaseManagement from '../Manage/CaseManagement';

import {
	checkModulePermissions,
	getDate,
	getUserName,
} from '../../utils/helper';
import moment from 'moment';
import CaseAnalysis from '../CaseAnalysis/CaseAnalysis';
import DonutChart from '../../components/Chart/DashboardChart';
import {
	getCaseChartDetailsApi,
	getCaseChartDetailsReset,
} from '../../actions/getCaseChartDetailsAction';
import {
	getTotalCaseAmountApi,
	getTotalCaseAmountReset,
} from '../../actions/getTotalCaseAmountAction';
import Header from '../../components/Header/Header';

import CaseClosure from '../CaseClosure/CaseClosure';
import FeedBackList from '../FeedBackAnalysis/FeedBackList';
import AppealLetter from '../AppealLetter/AppealLetter';

import {
	CaretDownOutlined,
	DownOutlined,
	InfoCircleOutlined,
	MoreOutlined,
	PlusOutlined,
	TwitterOutlined,
	UserOutlined,
} from '@ant-design/icons';
import {
	getInsuranceCompaniesStatisticsApi,
	getInsuranceCompaniesStatisticsReset,
} from '../../actions/getInsuranceCompaniesStatisticsAction';
import {
	getInsuranceCompaniesFilingStatusCountsApi,
	getInsuranceCompaniesFilingStatusCountsReset,
} from '../../actions/getInsuranceCompaniesFilingStatusCountsAction';
import {
	getInsuranceCompaniesBucketApi,
	getInsuranceCompaniesBucketReset,
} from '../../actions/getInsuranceCompaniesBucketAction';
import { XRadio, XRadioHeader } from '../CaseForm/CaseFormStyle';
import {
	getInsuranceDropdownApi,
	getInsuranceDropdownReset,
} from '../../actions/getInsuranceDropdownAction';
import {
	getCaseAmountBucketApi,
	getCaseAmountBucketReset,
} from '../../actions/getCaseAmountBucketAction';
import {
	getPreCalculatedDataApi,
	getPreCalculatedDataReset,
} from '../../actions/getPreCalculatedDataAction';
import { filterByLabel } from '../../utils/formFunctions';
import config from '../../config';
import HalfDonutChart from '../../components/Chart/DashboardHalfDonutChart';
import {
	XTheme2AvatarListCard,
	XTheme2Badge,
	XTheme2Card,
	XTheme2ChatBox,
	XTheme2CustomSelect,
	XTheme2DropdownStatus,
	XTheme2InnerCard,
	XTheme2InsurancePayerCard,
	XTheme2InsuranceSpace,
	XTheme2ListBtn,
	XTheme2ListCard,
	XTheme2Para1,
	XTheme2Progress,
	XTheme2Radio,
	XTheme2Refresh,
	XTheme2Segmented,
	XTheme2TextButton,
	XTheme2Title2,
	XTheme2ViewMoreListCard,
	XTheme2ViewMorePending,
	XTheme2ViewMoreTitle,
	XThemeDashboardLottieCard,
} from './DashboardStyleCQ';
import { getCountByFilingAndRevenueApi } from '../../actions/getCountByFilingAndRevenueAction';
import {
	HeaderTitle,
	XThemeDateDays,
} from '../../components/Header/HeaderStyle';

const Dashboard = (props) => {
	const {
		getCaseChartDetailsState,
		getCaseChartDetails,
		getCaseChartDetailsReset,
		getTotalCaseAmountState,
		getTotalCaseAmount,
		getTotalCaseAmountReset,
		getInsuranceCompaniesStatistics,
		getInsuranceCompaniesStatisticsState,
		getInsuranceCompaniesStatisticsReset,
		getInsuranceCompaniesFilingStatusCounts,
		getInsuranceCompaniesFilingStatusCountsState,
		getInsuranceCompaniesFilingStatusCountsReset,
		getInsuranceCompaniesBucket,
		getInsuranceCompaniesBucketState,
		getInsuranceCompaniesBucketReset,
		getInsuranceDropdown,
		getInsuranceDropdownState,
		getCaseAmountBucket,
		getCaseAmountBucketReset,
		getCaseAmountBucketState,
		getPreCalculatedData,
		getPreCalculatedDataReset,
		getPreCalculatedDataState,
		getCountByFilingAndRevenueState,
		getCountByFilingAndRevenue,
	} = props;
	// Initialize your default state values
	const defaultStatisticsFilters = {
		status: 'open',
	};
	const defaultTableFilters = {
		status: 'open',
	};
	const defaultScoreFilters = {
		status: 'open',
	};
	const navigate = useNavigate();
	const [chartData, setChartData] = useState({});
	const [caseAmount, setCaseAmount] = useState({});
	const [statisticsData, setStatisticsData] = useState({});
	const [statisticsTableData, setStatisticsTableData] = useState({});
	const [statisticsBucketData, setStatisticsBucketData] = useState({});
	const [totalCases, setTotalCases] = useState(0);
	const [lottieModalOpen, setLottieModalOpen] = useState(false);
	const [windowSize, setWindowSize] = useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});
	const [dashboardCounts, setDashboardCounts] = useState({
		at_risk_count: 0,
		rejected_count: 0,
		pending_count: 0,
		at_risk_amount: 0,
		rejected_amount: 0,
		pending_amount: 0,
	});

	const speedometerWidth = windowSize.width < 575 ? 200 : 350; // Adjust width based on screen size
	const speedometerHeight = windowSize.width < 575 ? 100 : 220;
	const ringWidth = windowSize.width < 575 ? 20 : 50;
	const [statisticsFilters, setStatisticsFilters] = useState(
		defaultStatisticsFilters,
	);
	const [activeStatisticsTimeFilter, setActiveStatisticsTimeFilter] =
		useState('');
	const [statisticsDateRange, setStatisticsDateRange] = useState(null);
	const [tableFilters, setTableFilters] = useState(defaultTableFilters);
	const [activeTableTimeFilter, setActiveTableTimeFilter] = useState('');
	const [tableDateRange, setTableDateRange] = useState(null);
	const [scoreFilters, setScoreFilters] = useState(defaultScoreFilters);
	const [activeScoreTimeFilter, setActiveScoreTimeFilter] = useState('');
	const [scoreDateRange, setScoreDateRange] = useState(null);
	const [scoreCardLoading, setScoreCardLoading] = useState(false);
	const [insuranceTableLoading, setInsuranceTableLoading] = useState(false);
	const [statisticsGraphLoading, setStatisticsGraphLoading] = useState(false);
	const [shouldCallAnotherApi, setShouldCallAnotherApi] = useState(false);
	const [dashboardPreCalculatedData, setDashboardPreCalculatedData] =
		useState({});
	const [selectedChartOption, setSelectedChartOption] = useState('Total');
	const [selectedAmountOption, setSelectedAmountOption] = useState('Total');
	const [selectedReimbursementOption, setSelectedReimbursementOption] =
		useState('Total');
	const [expandedCards, setExpandedCards] = useState({});
	const [open, setOpen] = useState(false);

	const getGreeting = () => {
		const currentHour = moment().hour();

		if (currentHour >= 5 && currentHour < 12) {
			return 'Good Morning,';
		} else if (currentHour >= 12 && currentHour < 17) {
			return 'Good Afternoon,';
		} else {
			return 'Good Evening,';
		}
	};

	console.log('chartData---------------', chartData);

	const formatNumber = (cost) => {
		if (cost === 0) {
			return '0';
		}
		const costFloat = parseFloat(cost);
		const suffixes = ['K', 'M', 'B', 'T'];

		let formattedCost = costFloat;

		let suffix = '';
		for (const s of suffixes) {
			if (formattedCost < 1000) {
				break;
			}
			formattedCost /= 1000.0;
			suffix = s;
		}

		// Use parseFloat to remove trailing zeros after decimal
		// return `${parseFloat(formattedCost.toFixed(2))}${suffix}`;
		return `${Math.round(formattedCost)}${suffix}`;
		//Old
		// return `${formattedCost.toFixed(2)}${suffix}`;
	};

	const renderComponentBasedOnPermission = () => {
		if (localStorage.getItem('role') === 'super-admin') return <></>;
		else if (checkModulePermissions('case-management').authorized) {
			return <CaseManagement displayHeader={true} />;
		} else if (checkModulePermissions('case-analysis').authorized) {
			return <CaseAnalysis displayHeader={true} />;
		} else if (checkModulePermissions('case-closure').authorized) {
			return <CaseClosure displayHeader={false} />;
		} else if (checkModulePermissions('appeal-letter').authorized) {
			return <AppealLetter displayHeader={true} />;
		} else if (checkModulePermissions('feedback-analysis').authorized) {
			return <FeedBackList displayHeader={true} />;
		} else {
			return <></>;
		}
	};

	useEffect(() => {
		if (getPreCalculatedDataState.apiState === 'loading') {
			setStatisticsGraphLoading(true);
			setInsuranceTableLoading(true);
			setScoreCardLoading(true);
		}
		if (getPreCalculatedDataState.apiState === 'success') {
			if (getPreCalculatedDataState.data) {
				setDashboardPreCalculatedData(getPreCalculatedDataState.data);
				setCaseAmount(getPreCalculatedDataState.data?.reimbursement);
				setStatisticsData(
					getPreCalculatedDataState.data?.insurance_company_statistics
						?.for_open,
				);
				setStatisticsTableData(
					getPreCalculatedDataState.data
						?.insurance_company_filing_status_count?.for_open,
				);
				setStatisticsBucketData(
					getPreCalculatedDataState.data?.payer_score_card,
				);
				setChartData(
					getPreCalculatedDataState.data?.donutChart?.all_counts,
				);
				setTotalCases(
					getPreCalculatedDataState.data?.donutChart?.total,
				);
			} else {
				setDashboardPreCalculatedData({});
				setShouldCallAnotherApi(true);
			}
			setStatisticsGraphLoading(false);
			setInsuranceTableLoading(false);
			setScoreCardLoading(false);
		}
		if (getPreCalculatedDataState.apiState === 'error') {
			setStatisticsGraphLoading(false);
			setInsuranceTableLoading(false);
			setScoreCardLoading(false);
		}
		getPreCalculatedDataReset();
	}, [getPreCalculatedDataState]);

	useEffect(() => {
		if (
			localStorage.getItem('role') === 'md-advisor' ||
			localStorage.getItem('role') === 'coding-team' ||
			localStorage.getItem('role') === 'case-analyzer'
		) {
			setShouldCallAnotherApi(true);
		} else {
			getPreCalculatedData();
		}
	}, []);

	useEffect(() => {
		if (shouldCallAnotherApi) {
			getCaseChartDetails();
			getCaseAmountBucket();
		}

		const hasPermission =
			checkModulePermissions('dashboard').sub_modules.includes(
				'view-case-amount',
			);
		if (hasPermission) {
			if (shouldCallAnotherApi) {
				getTotalCaseAmount();
			}
			// getInsuranceCompaniesStatistics();
			// getInsuranceCompaniesFilingStatusCounts();
			// getInsuranceCompaniesBucket();
		}
	}, [shouldCallAnotherApi]);

	useEffect(() => {
		if (getTotalCaseAmountState.apiState === 'success') {
			setCaseAmount((prevCaseAmount) => ({
				...prevCaseAmount,
				approvedAmount: getTotalCaseAmountState.data.approvedAmount,
				pendingAmount: getTotalCaseAmountState.data.pendingAmount,
				rejectedAmount: getTotalCaseAmountState.data.rejectedAmount,
			}));
			getTotalCaseAmountReset();
		}
	}, [getTotalCaseAmountState]);

	useEffect(() => {
		if (
			getCaseAmountBucketState.apiState === 'success' &&
			getCaseAmountBucketState.data
		) {
			setCaseAmount((prevCaseAmount) => ({
				...prevCaseAmount,
				...getCaseAmountBucketState.data,
			}));
			getCaseAmountBucketReset();
		}
	}, [getCaseAmountBucketState]);

	useEffect(() => {
		if (getCaseChartDetailsState.apiState === 'success') {
			setChartData(getCaseChartDetailsState.data.data.all_counts);
			setTotalCases(getCaseChartDetailsState.data.data.total);
		}
		getCaseChartDetailsReset();
	}, [getCaseChartDetailsState]);

	//New API for Dashboard
	useEffect(() => {
		getCountByFilingAndRevenue();
	}, []);

	useEffect(() => {
		if (getCountByFilingAndRevenueState.apiState === 'success') {
			const data = getCountByFilingAndRevenueState.data;
			if (data.dashboard_counts) {
				setDashboardCounts(data.dashboard_counts);
			}
		}
	}, [getCountByFilingAndRevenueState]);

	// Statistics Start

	// todo revert to original function when the database response will be fast
	// useEffect(() => {
	// 	if (Object.keys(statisticsFilters).length > 0) {
	// 		getInsuranceCompaniesStatistics(statisticsFilters);
	// 	}
	// }, [statisticsFilters]);

	const hardcodedOpenResponse = {
		open_cases: {
			amount: {
				totalAmount: 7673963,
				in_process: 7102773,
				at_risk: 169265,
				escalation: 15000,
				untimely: 386925,
			},
			filingStatusCounts: {
				in_process: 155,
				untimely: 27,
				escalation: 3,
				at_risk: 9,
			},
			filingStatusPercentages: {
				in_process: 79,
				untimely: 14,
				escalation: 2,
				at_risk: 5,
			},
			totalCases: 194,
		},
		close_cases: {
			approvedAndPaid: 0,
			approvedAndNotPaid: 0,
			rejectedAmount: 0,
			totalAmount: 7673963,
			approvedAndPaidCount: '0.00',
			approvedAndNotPaidCount: '0.00',
			rejectedCaseCount: '0.00',
		},
	};

	const hardcodedClosedResponses = {
		open_cases: {
			amount: {
				totalAmount: 793825,
				in_process: 353000,
				at_risk: 98000,
				escalation: 40000,
				untimely: 302825,
			},
			filingStatusCounts: {
				in_process: 9,
				untimely: 17,
				escalation: 4,
				at_risk: 8,
			},
			filingStatusPercentages: {
				in_process: 24,
				untimely: 44,
				escalation: 11,
				at_risk: 21,
			},
			totalCases: 38,
		},
		close_cases: {
			approvedAndPaid: 126857,
			approvedAndNotPaid: 15000,
			rejectedAmount: 577000,
			totalAmount: 793825,
			approvedAndPaidCount: '13.16',
			approvedAndNotPaidCount: '2.63',
			rejectedCaseCount: '81.58',
		},
	};

	useEffect(() => {
		if (Object.keys(statisticsFilters).length > 0) {
			// Check if only the status filter is present, and it's either "open" or "closed"
			if (shouldCallAnotherApi) {
				getInsuranceCompaniesStatistics(statisticsFilters);
			} else {
				if (
					Object.keys(statisticsFilters).length === 1 &&
					(statisticsFilters.status === 'open' ||
						statisticsFilters.status === 'closed')
				) {
					// Show loading state
					setStatisticsGraphLoading(true);
					const delay = setTimeout(() => {
						// Set hardcoded response based on status
						if (
							statisticsFilters.status === 'open' &&
							Object.keys(dashboardPreCalculatedData).length > 0
						) {
							setStatisticsGraphLoading(false);

							if (
								dashboardPreCalculatedData?.insurance_company_statistics
							) {
								setStatisticsData(
									dashboardPreCalculatedData
										?.insurance_company_statistics
										?.for_open,
								);
							}
						} else if (
							statisticsFilters.status === 'closed' &&
							Object.keys(dashboardPreCalculatedData).length > 0
						) {
							setStatisticsGraphLoading(false);
							if (
								dashboardPreCalculatedData?.insurance_company_statistics
							) {
								setStatisticsData(
									dashboardPreCalculatedData
										?.insurance_company_statistics
										?.for_close,
								);
							}
						}
					}, 1000); // 1 second delay
					// Clean up the timeout if the component unmounts or filters change
					return () => clearTimeout(delay);
				} else {
					// If there are additional filters, make the API call as usual
					getInsuranceCompaniesStatistics(statisticsFilters);
				}
			}
		}
	}, [statisticsFilters, shouldCallAnotherApi]);

	const handleStatisticsFilterChange = (updatedFilter) => {
		setStatisticsFilters((prevFilters) => {
			const newFilters = { ...prevFilters, ...updatedFilter };

			// Remove keys with empty values
			Object.keys(newFilters).forEach((key) => {
				if (newFilters[key] === '') {
					delete newFilters[key];
				}
			});

			return newFilters;
		});
	};

	const handleStatisticsTimeFilterClick = (timeFilter) => {
		if (activeStatisticsTimeFilter === timeFilter) {
			return;
			// // If the same filter is clicked again, remove it
			// setActiveStatisticsTimeFilter('');
			// handleStatisticsFilterChange({
			// 	created_on: '',
			// 	year_to_date: '',
			// 	from: '',
			// 	to: '',
			// });
		} else {
			// If a different filter is clicked, activate it and deactivate others
			setActiveStatisticsTimeFilter(timeFilter);

			const updatedFilter = {
				created_on: '',
				year_to_date: '',
				from: '',
				to: '',
			};

			if (timeFilter === 'year_to_date') {
				updatedFilter.year_to_date = 'true';
			} else {
				updatedFilter.created_on = timeFilter;
			}

			handleStatisticsFilterChange(updatedFilter);
			setStatisticsDateRange(null); // Clear the date range selection
		}
	};

	const handleStatisticsDateRangeChange = (dates) => {
		if (dates && dates.length === 2) {
			setStatisticsDateRange(dates);
			handleStatisticsFilterChange({
				created_on: 'custom',
				from: dates[0],
				to: dates[1],
				year_to_date: '',
			});
			setActiveStatisticsTimeFilter('');
		} else {
			setStatisticsDateRange(null);
			handleStatisticsFilterChange({
				created_on: '',
				from: '',
				to: '',
			});
		}
	};

	const handleStatisticsClearFilters = () => {
		setStatisticsFilters({
			status: statisticsFilters.status,
		});
		setActiveStatisticsTimeFilter('');
		setStatisticsDateRange(null);
	};

	const statisticsFiltersApplied = Object.keys(statisticsFilters).some(
		(key) =>
			key !== 'status' &&
			statisticsFilters[key] &&
			statisticsFilters[key] !== defaultStatisticsFilters[key],
	);

	const statusSpeedometer = () => {
		const { in_process, at_risk, untimely } =
			statisticsData.filingStatusPercentages;
		const totalPercentages = in_process + at_risk + untimely;

		// Create segments array
		const segments = [
			{ key: 'in_process', value: in_process },
			{ key: 'at_risk', value: at_risk },
			{ key: 'untimely', value: untimely },
		];

		// Calculate custom segment stops
		const minWidth = 60; // Minimum width reserved for each segment
		const customSegmentStops = [
			0,
			...adjustSegmentStopsWithMinWidth(
				segments,
				totalPercentages,
				minWidth,
			),
		];

		const segmentColorsOpen = ['#1F9254', '#E5AA11', '#E53711'];
		const segmentColorsClosed = ['#2F8DFA', '#1FD0BF', '#D5001A'];
		const segmentColors =
			statisticsFilters.status === 'open'
				? segmentColorsOpen
				: segmentColorsClosed;

		// Update segment labels to have empty text if value is zero
		const customSegmentLabels = [
			{
				text: in_process !== 0 ? `${in_process}%` : '',
				position: 'INSIDE',
				color: '#FFF',
			},
			{
				text: at_risk !== 0 ? `${at_risk}%` : '',
				position: 'INSIDE',
				color: '#FFF',
			},
			{
				text: untimely !== 0 ? `${untimely}%` : '',
				position: 'INSIDE',
				color: '#FFF',
			},
		];

		return (
			<XThemeReactSpeedometer
				forceRender={true}
				width={speedometerWidth}
				height={speedometerHeight}
				needleHeightRatio={''}
				customSegmentStops={customSegmentStops}
				segmentColors={segmentColors}
				currentValueText={' '}
				valueTextFontSize="20px"
				labelFontSize="13px"
				paddingHorizontal={0}
				paddingVertical={0}
				customSegmentLabels={customSegmentLabels}
				ringWidth={ringWidth}
				needleTransitionDuration={''}
				needleTransition="easeElastic"
				needleColor={'none'}
				textColor={'#000'}
			/>
		);
	};

	const adjustSegmentStopsWithMinWidth = (
		segments,
		totalPercentages,
		minWidth,
	) => {
		// Calculate total reserved width for segments with data
		const reservedWidth =
			minWidth * segments.filter((segment) => segment.value > 0).length;
		const remainingWidth = 1000 - reservedWidth;

		let cumulative = 0;
		return segments.map((segment, index) => {
			let allocatedWidth = 0;
			if (segment.value > 0) {
				allocatedWidth =
					(segment.value / totalPercentages) * remainingWidth +
					minWidth;
			} else {
				allocatedWidth =
					(segment.value / totalPercentages) * remainingWidth;
			}
			cumulative += allocatedWidth;
			return index === segments.length - 1 ? 1000 : cumulative;
		});
	};

	const amountSpeedometer = () => {
		const { in_process, at_risk, untimely } = statisticsData.amount;
		const totalPercentages = in_process + at_risk + untimely;

		// Create segments array
		const segments = [
			{ key: 'in_process', value: in_process },
			{ key: 'at_risk', value: at_risk },
			{ key: 'untimely', value: untimely },
		];

		// Calculate custom segment stops
		const minWidth = 150; // Minimum width reserved for each segment
		const customSegmentStops = [
			0,
			...adjustSegmentStopsWithMinWidth(
				segments,
				totalPercentages,
				minWidth,
			),
		];

		const segmentColorsOpen = ['#1F9254', '#E5AA11', '#E53711'];
		const segmentColorsClosed = ['#2F8DFA', '#1FD0BF', '#D5001A'];
		const segmentColors =
			statisticsFilters.status === 'open'
				? segmentColorsOpen
				: segmentColorsClosed;

		// Update segment labels to have empty text if value is zero
		const customSegmentLabels = [
			{
				text: in_process !== 0 ? formatNumber(in_process) : '',
				position: 'INSIDE',
				color: '#FFF',
			},
			{
				text: at_risk !== 0 ? formatNumber(at_risk) : '',
				position: 'INSIDE',
				color: '#FFF',
			},
			{
				text: untimely !== 0 ? formatNumber(untimely) : '',
				position: 'INSIDE',
				color: '#FFF',
			},
		];

		return (
			<XThemeReactSpeedometer
				forceRender={true}
				width={speedometerWidth}
				height={speedometerHeight}
				needleHeightRatio={''}
				customSegmentStops={customSegmentStops}
				segmentColors={segmentColors}
				currentValueText={' '}
				labelFontSize="13px"
				valueTextFontSize="20px"
				paddingHorizontal={0}
				paddingVertical={0}
				customSegmentLabels={customSegmentLabels}
				ringWidth={ringWidth}
				needleTransitionDuration={''}
				needleTransition="easeElastic"
				needleColor={'none'}
				textColor={'#000'}
			/>
		);
	};

	const getStatisticsLegends = () => {
		if (statisticsFilters.status === 'open') {
			return [
				{ className: 'color1', text: 'In Process' },
				{ className: 'color2', text: 'At-Risk' },
				{ className: 'color3', text: 'Untimely' },
			];
		} else {
			return [
				{ className: 'color4', text: 'Approved and Paid' },
				{ className: 'color5', text: 'Approved but not Reimbursed' },
				{ className: 'color6', text: 'Rejected' },
			];
		}
	};

	useEffect(() => {
		const handleResize = () => {
			setWindowSize({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [setWindowSize]);

	useEffect(() => {
		if (getInsuranceCompaniesStatisticsState.apiState === 'loading') {
			setStatisticsGraphLoading(true);
		}
		if (getInsuranceCompaniesStatisticsState.apiState === 'success') {
			setStatisticsData(getInsuranceCompaniesStatisticsState.data);
			setStatisticsGraphLoading(false);
		}
		if (getInsuranceCompaniesStatisticsState.apiState === 'error') {
			setStatisticsGraphLoading(false);
		}
		getInsuranceCompaniesStatisticsReset();
	}, [getInsuranceCompaniesStatisticsState]);
	//Statistics End

	// Table Start
	useEffect(() => {
		if (Object.keys(tableFilters).length > 0) {
			if (shouldCallAnotherApi) {
				getInsuranceCompaniesFilingStatusCounts(tableFilters);
			} else {
				if (
					Object.keys(tableFilters).length === 1 &&
					(tableFilters.status === 'open' ||
						tableFilters.status === 'closed')
				) {
					setInsuranceTableLoading(true);
					if (
						tableFilters.status === 'open' &&
						Object.keys(dashboardPreCalculatedData).length > 0
					) {
						setStatisticsTableData(
							dashboardPreCalculatedData
								?.insurance_company_filing_status_count
								?.for_open,
						);
						setInsuranceTableLoading(false);
					} else if (
						tableFilters.status === 'closed' &&
						Object.keys(dashboardPreCalculatedData).length > 0
					) {
						setStatisticsTableData(
							dashboardPreCalculatedData
								?.insurance_company_filing_status_count
								?.for_close,
						);

						setInsuranceTableLoading(false);
					}
				} else {
					getInsuranceCompaniesFilingStatusCounts(tableFilters);
				}
			}
		}
	}, [tableFilters, shouldCallAnotherApi]);

	// function adjustTableGraphWidths(widths) {
	// 	const total = widths.reduce((sum, width) => sum + width, 0);
	// 	const roundedWidths = widths.map((width) => Math.round(width));
	// 	const roundedTotal = roundedWidths.reduce(
	// 		(sum, width) => sum + width,
	// 		0,
	// 	);

	// 	if (roundedTotal === 100) return roundedWidths;

	// 	const difference = 100 - roundedTotal;
	// 	roundedWidths[0] += difference; // Adjust the first item to ensure the total is 100
	// 	return roundedWidths;
	// }

	// function adjustTableGraphWidths(widths) {
	// 	let adjustedWidths = widths.map(width => {
	// 		if (width < 1) {
	// 			return 1; // Set width to 1% if it's less than 1%
	// 		} else {
	// 			return Math.floor(width); // Use only the integer part of the width
	// 		}
	// 	});

	// 	// Calculate the sum of the adjusted widths
	// 	const totalWidth = adjustedWidths.reduce((sum, width) => sum + width, 0);

	// 	// Calculate the difference to 100% and distribute it proportionally
	// 	const remainingWidth = 100 - totalWidth;

	// 	if (remainingWidth !== 0) {
	// 		const totalOriginalWidth = widths.reduce((sum, width) => sum + width, 0);
	// 		adjustedWidths = adjustedWidths.map((width, index) => {
	// 			const originalProportion = widths[index] / totalOriginalWidth;
	// 			return width + Math.round(originalProportion * remainingWidth);
	// 		});
	// 	}

	// 	return adjustedWidths;
	// }

	function adjustTableGraphWidths(widths) {
		let adjustedWidths = widths.map((width) => {
			if (width < 1) {
				return 1; // Set width to 1% if it's less than 1%
			} else {
				return Math.floor(width); // Use only the integer part of the width
			}
		});

		// Calculate the sum of the adjusted widths
		let totalWidth = adjustedWidths.reduce((sum, width) => sum + width, 0);

		// If there's a remaining percentage, distribute it
		if (totalWidth < 100) {
			const remainingWidth = 100 - totalWidth;

			// Distribute the remaining width proportionally
			adjustedWidths = adjustedWidths.map((width, index) => {
				if (index === 0) {
					return width + remainingWidth; // Add remainder to the first element
				}
				return width;
			});

			// Recalculate the total width to ensure it sums up to 100%
			totalWidth = adjustedWidths.reduce((sum, width) => sum + width, 0);
		}

		return adjustedWidths;
	}

	const handleTableFilterChange = (updatedFilter) => {
		setTableFilters((prevFilters) => {
			const newFilters = { ...prevFilters, ...updatedFilter };
			// Remove keys with empty values
			Object.keys(newFilters).forEach((key) => {
				if (newFilters[key] === '') {
					delete newFilters[key];
				}
			});
			return newFilters;
		});
	};

	const handleTableTimeFilterClick = (timeFilter) => {
		if (activeTableTimeFilter === timeFilter) {
			return;
			// // If the same filter is clicked again, remove it
			// setActiveTableTimeFilter('');
			// handleTableFilterChange({
			// 	created_on: '',
			// 	year_to_date: '',
			// 	from: '',
			// 	to: '',
			// });
		} else {
			// If a different filter is clicked, activate it and deactivate others
			setActiveTableTimeFilter(timeFilter);

			const updatedFilter = {
				created_on: '',
				year_to_date: '',
				from: '',
				to: '',
			};

			if (timeFilter === 'year_to_date') {
				updatedFilter.year_to_date = 'true';
			} else {
				updatedFilter.created_on = timeFilter;
			}

			handleTableFilterChange(updatedFilter);
			setTableDateRange(null); // Clear the date range selection
		}
	};

	const handleTableDateRangeChange = (dates) => {
		if (dates && dates.length === 2) {
			setTableDateRange(dates);
			handleTableFilterChange({
				created_on: 'custom',
				from: dates[0],
				to: dates[1],
				year_to_date: '',
			});
			setActiveTableTimeFilter('');
		} else {
			setTableDateRange(null);
			handleTableFilterChange({
				created_on: '',
				from: '',
				to: '',
			});
		}
	};

	const handleTableClearFilters = () => {
		setTableFilters({
			status: tableFilters.status,
		});
		setActiveTableTimeFilter('');
		setTableDateRange(null);
	};

	const tableFiltersApplied = Object.keys(tableFilters).some(
		(key) =>
			key !== 'status' &&
			tableFilters[key] &&
			tableFilters[key] !== defaultTableFilters[key],
	);

	const getGraphColorClassNames = () => {
		if (tableFilters.status === 'open') {
			return ['step1', 'step2', 'step3'];
		} else {
			return ['step4', 'step5', 'step6'];
		}
	};

	const getTableLegends = () => {
		if (tableFilters.status === 'open') {
			return [
				{ className: 'color1', text: 'In Process' },
				{ className: 'color2', text: 'At-Risk' },
				{ className: 'color3', text: 'Untimely' },
			];
		} else {
			return [
				{ className: 'color4', text: 'Approved and Paid' },
				{ className: 'color5', text: 'Approved but not Reimbursed' },
				{ className: 'color6', text: 'Rejected' },
			];
		}
	};

	const graphColor = getGraphColorClassNames();

	const columns = [
		{
			title: 'Insurance Payer',
			dataIndex: 'company_name',
			width: '20%',
		},
		{
			title: '% Rejected',
			dataIndex: 'rejection',
			width: '10%',
			align: 'center', // Add this line
		},
		{
			title: '% Overturned',
			dataIndex: 'overturned',
			width: '10%',
			align: 'center', // Add this line
		},
		{
			title: (
				<>
					<Space>
						case status
						<Tooltip
							id="tooltip-card"
							title={
								<Row
									gutter={(15, 15)}
									className="align-items-center "
								>
									<Col xs={24} className="text-center">
										<ul className="markData">
											{getTableLegends().map(
												(label, index) => (
													<li key={index}>
														<em
															className={
																label.className
															}
														>
															&nbsp;
														</em>{' '}
														{label.text}
													</li>
												),
											)}
										</ul>
									</Col>
								</Row>
							}
						>
							<InfoCircleOutlined />
						</Tooltip>
					</Space>
				</>
			),
			dataIndex: 'graph1',
			align: 'center',
			width: '30%',
		},
		{
			title: (
				<>
					<Space>
						Cases value
						<Tooltip
							id="tooltip-card"
							title={
								<Row
									gutter={(15, 15)}
									className="align-items-center "
								>
									<Col xs={24} className="text-center">
										<ul className="markData">
											{getTableLegends().map(
												(label, index) => (
													<li key={index}>
														<em
															className={
																label.className
															}
														>
															&nbsp;
														</em>{' '}
														{label.text}
													</li>
												),
											)}
										</ul>
									</Col>
								</Row>
							}
						>
							<InfoCircleOutlined />
						</Tooltip>
					</Space>
				</>
			),
			dataIndex: 'graph2',
			align: 'center',
			width: '30%',
		},
	];

	const data =
		statisticsTableData &&
		statisticsTableData.insuranceCompanies?.map((company, index) => {
			const totalCasesCount =
				company.filingStatusCounts.in_process +
				company.filingStatusCounts.at_risk +
				company.filingStatusCounts.untimely;

			const totalAmount =
				company.amount.in_process +
				company.amount.at_risk +
				company.amount.untimely;

			const caseWidths = adjustTableGraphWidths([
				(company.filingStatusCounts.in_process / totalCasesCount) * 100,
				(company.filingStatusCounts.at_risk / totalCasesCount) * 100,
				(company.filingStatusCounts.untimely / totalCasesCount) * 100,
			]);

			const amountWidths = adjustTableGraphWidths([
				(company.amount.in_process / totalAmount) * 100,
				(company.amount.at_risk / totalAmount) * 100,
				(company.amount.untimely / totalAmount) * 100,
			]);
			return {
				key: index.toString(),
				company_name: company.insuranceCompanyName,
				rejection:
					company.rejectedPercentage !== null
						? `${company.rejectedPercentage}%`
						: '-',
				overturned:
					company.overturnedPercentage !== null
						? `${company.overturnedPercentage}%`
						: '-',
				graph1: (
					<>
						<ul
							className="barGraph"
							style={{
								display: 'flex',
							}}
						>
							{totalCasesCount ? (
								<>
									{company.filingStatusCounts.in_process >
										0 && (
										<Tooltip
											title={
												company.filingStatusCounts
													.in_process
											}
										>
											<li
												style={{
													width: `${caseWidths[0]}%`,
													flexGrow: 1, // Apply flex-grow for equal distribution
													minWidth: '60px', // Minimum width of 30px
													textAlign: 'center',
												}}
												className={graphColor[0]}
											>
												<span
													ref={(el) => {
														if (el) {
															const isOverflowing =
																el.scrollWidth >
																el.clientWidth;
															el.style.visibility =
																isOverflowing
																	? 'hidden'
																	: 'visible'; // Hides text if overflowing
														}
													}}
													style={{
														display: 'inline-block',
														whiteSpace: 'nowrap',
														overflow: 'hidden',
														textOverflow:
															'ellipsis',
														maxWidth: '100%',
													}}
												>
													{Math.round(
														company
															.filingStatusCounts
															.in_process,
													)}
												</span>
											</li>
										</Tooltip>
									)}
									{company.filingStatusCounts.at_risk > 0 && (
										<Tooltip
											title={
												company.filingStatusCounts
													.at_risk
											}
										>
											<li
												style={{
													width: `${caseWidths[1]}%`,
													flexGrow: 1, // Apply flex-grow for equal distribution
													minWidth: '60px', // Minimum width of 30px
													textAlign: 'center',
												}}
												className={graphColor[1]}
											>
												<span
													ref={(el) => {
														if (el) {
															const isOverflowing =
																el.scrollWidth >
																el.clientWidth;
															el.style.visibility =
																isOverflowing
																	? 'hidden'
																	: 'visible'; // Hides text if overflowing
														}
													}}
													style={{
														display: 'inline-block',
														whiteSpace: 'nowrap',
														overflow: 'hidden',
														textOverflow:
															'ellipsis',
														maxWidth: '100%',
													}}
												>
													{Math.round(
														company
															.filingStatusCounts
															.at_risk,
													)}
												</span>
											</li>
										</Tooltip>
									)}
									{company.filingStatusCounts.untimely >
										0 && (
										<Tooltip
											title={
												company.filingStatusCounts
													.untimely
											}
										>
											<li
												style={{
													width: `${caseWidths[2]}%`,
													flexGrow: 1, // Apply flex-grow for equal distribution
													minWidth: '60px', // Minimum width of 30px
													textAlign: 'center',
												}}
												className={graphColor[2]}
											>
												<span
													ref={(el) => {
														if (el) {
															const isOverflowing =
																el.scrollWidth >
																el.clientWidth;
															el.style.visibility =
																isOverflowing
																	? 'hidden'
																	: 'visible'; // Hides text if overflowing
														}
													}}
													style={{
														display: 'inline-block',
														whiteSpace: 'nowrap',
														overflow: 'hidden',
														textOverflow:
															'ellipsis',
														maxWidth: '100%',
													}}
												>
													{Math.round(
														company
															.filingStatusCounts
															.untimely,
													)}
												</span>
											</li>
										</Tooltip>
									)}
								</>
							) : (
								<li className="w-100">0</li>
							)}
						</ul>
					</>
				),
				graph2: (
					<>
						<ul
							className="barGraph"
							style={{
								display: 'flex',
							}}
						>
							{totalAmount ? (
								<>
									{company.amount.in_process > 0 && (
										<Tooltip
											title={`$${formatNumber(
												company.amount.in_process,
											)}`}
										>
											<li
												style={{
													width: `${amountWidths[0]}%`,
													flexGrow: 1, // Apply flex-grow for equal distribution
													minWidth: '60px', // Minimum width of 30px
													textAlign: 'center', // Center the text
												}}
												className={graphColor[0]}
											>
												<span
													ref={(el) => {
														if (el) {
															const isOverflowing =
																el.scrollWidth >
																el.clientWidth;
															el.style.visibility =
																isOverflowing
																	? 'hidden'
																	: 'visible'; // Hides text if overflowing
														}
													}}
													style={{
														display: 'inline-block',
														whiteSpace: 'nowrap',
														overflow: 'hidden',
														textOverflow:
															'ellipsis',
														maxWidth: '100%',
													}}
												>
													$
													{formatNumber(
														company.amount
															.in_process,
													)}
												</span>
											</li>
										</Tooltip>
									)}
									{company.amount.at_risk > 0 && (
										<Tooltip
											title={`$${formatNumber(
												company.amount.at_risk,
											)}`}
										>
											<li
												style={{
													width: `${amountWidths[1]}%`,
													flexGrow: 1, // Apply flex-grow for equal distribution
													minWidth: '60px', // Minimum width of 30px
													textAlign: 'center', // Center the text
												}}
												className={graphColor[1]}
											>
												<span
													ref={(el) => {
														if (el) {
															const isOverflowing =
																el.scrollWidth >
																el.clientWidth;
															el.style.visibility =
																isOverflowing
																	? 'hidden'
																	: 'visible'; // Hides text if overflowing
														}
													}}
													style={{
														display: 'inline-block',
														whiteSpace: 'nowrap',
														overflow: 'hidden',
														textOverflow:
															'ellipsis',
														maxWidth: '100%',
													}}
												>
													$
													{formatNumber(
														company.amount.at_risk,
													)}
												</span>
											</li>
										</Tooltip>
									)}
									{company.amount.untimely > 0 && (
										<Tooltip
											title={`$${formatNumber(
												company.amount.untimely,
											)}`}
										>
											<li
												style={{
													width: `${amountWidths[2]}%`,
													flexGrow: 1, // Apply flex-grow for equal distribution
													minWidth: '60px', // Minimum width of 30px
													textAlign: 'center', // Center the text
												}}
												className={graphColor[2]}
											>
												<span
													ref={(el) => {
														if (el) {
															const isOverflowing =
																el.scrollWidth >
																el.clientWidth;
															el.style.visibility =
																isOverflowing
																	? 'hidden'
																	: 'visible'; // Hides text if overflowing
														}
													}}
													style={{
														display: 'inline-block',
														whiteSpace: 'nowrap',
														overflow: 'hidden',
														textOverflow:
															'ellipsis',
														maxWidth: '100%',
													}}
												>
													$
													{formatNumber(
														company.amount.untimely,
													)}
												</span>
											</li>
										</Tooltip>
									)}
								</>
							) : (
								<li className="w-100">0</li>
							)}
						</ul>
					</>
				),
			};
		});

	useEffect(() => {
		if (
			getInsuranceCompaniesFilingStatusCountsState.apiState === 'loading'
		) {
			setInsuranceTableLoading(true);
		}
		if (
			getInsuranceCompaniesFilingStatusCountsState.apiState === 'success'
		) {
			setStatisticsTableData(
				getInsuranceCompaniesFilingStatusCountsState.data,
			);

			setInsuranceTableLoading(false);
		}
		if (getInsuranceCompaniesFilingStatusCountsState.apiState === 'error') {
			setInsuranceTableLoading(false);
		}
		getInsuranceCompaniesFilingStatusCountsReset();
	}, [getInsuranceCompaniesFilingStatusCountsState]);
	// Table End

	// Score Start
	useEffect(() => {
		if (Object.keys(scoreFilters).length > 0) {
			if (shouldCallAnotherApi) {
				getInsuranceCompaniesBucket(scoreFilters);
			} else {
				if (
					Object.keys(scoreFilters).length === 1 &&
					scoreFilters.status === 'open'
				) {
					// Show loading state
					setScoreCardLoading(true);
					const delay = setTimeout(() => {
						// Set hardcoded response based on status
						if (
							scoreFilters.status === 'open' &&
							Object.keys(dashboardPreCalculatedData).length > 0
						) {
							setScoreCardLoading(false);

							if (dashboardPreCalculatedData?.payer_score_card) {
								setStatisticsBucketData(
									dashboardPreCalculatedData?.payer_score_card,
								);
							}
						}
					}, 1000); // 1 second delay
					// Clean up the timeout if the component unmounts or filters change
					return () => clearTimeout(delay);
				} else {
					getInsuranceCompaniesBucket(scoreFilters);
				}
			}
		}
	}, [scoreFilters, shouldCallAnotherApi]);

	const handleScoreFilterChange = (updatedFilter) => {
		setScoreFilters((prevFilters) => {
			const newFilters = { ...prevFilters, ...updatedFilter };

			// Remove keys with empty values
			Object.keys(newFilters).forEach((key) => {
				if (newFilters[key] === '') {
					delete newFilters[key];
				}
			});

			return newFilters;
		});
	};

	const handleScoreTimeFilterClick = (timeFilter) => {
		if (activeScoreTimeFilter === timeFilter) {
			return;
			// // If the same filter is clicked again, remove it
			// setActiveScoreTimeFilter('');
			// handleScoreFilterChange({
			// 	created_on: '',
			// 	year_to_date: '',
			// 	from: '',
			// 	to: '',
			// });
		} else {
			// If a different filter is clicked, activate it and deactivate others
			setActiveScoreTimeFilter(timeFilter);

			const updatedFilter = {
				created_on: '',
				year_to_date: '',
				from: '',
				to: '',
			};

			if (timeFilter === 'year_to_date') {
				updatedFilter.year_to_date = 'true';
			} else {
				updatedFilter.created_on = timeFilter;
			}

			handleScoreFilterChange(updatedFilter);
			setTableDateRange(null); // Clear the date range selection
		}
	};

	const handleScoreDateRangeChange = (dates) => {
		if (dates && dates.length === 2) {
			setScoreDateRange(dates);
			handleScoreFilterChange({
				created_on: 'custom',
				from: dates[0],
				to: dates[1],
				year_to_date: '',
			});
			setActiveScoreTimeFilter('');
		} else {
			setScoreDateRange(null);
			handleScoreFilterChange({
				created_on: '',
				from: '',
				to: '',
			});
		}
	};

	const handleScoreClearFilters = () => {
		setScoreFilters({
			status: scoreFilters.status,
		});
		setActiveScoreTimeFilter('');
		setScoreDateRange(null);
	};

	const scoreFiltersApplied = Object.keys(scoreFilters).some(
		(key) =>
			key !== 'status' &&
			scoreFilters[key] &&
			scoreFilters[key] !== defaultTableFilters[key],
	);

	const getScoreCardParameterClassName = (percentage, is_negative) => {
		if (is_negative) percentage = 100 - percentage;
		if (percentage <= 25) {
			return 'list2Color1'; // Red color class
		} else if (percentage > 25 && percentage <= 50) {
			return 'list2Color2'; // Orange color class
		} else if (percentage > 50 && percentage <= 75) {
			return 'list2Color3'; // Yellow color class
		} else if (percentage > 75) {
			return 'list2Color4'; // Green color class
		} else {
			return 'list2Color1'; // Red color class
		}
	};

	const getScoreCardHeaderClassName = (percentage) => {
		if (percentage < 20) {
			return 'headerColor1'; // Red color class
		} else if (percentage >= 20 && percentage < 50) {
			return 'headerColor2'; // Orange color class
		} else if (percentage >= 50 && percentage < 80) {
			return 'headerColor3'; // Yellow color class
		} else if (percentage > 80) {
			return 'headerColor4'; // Green color class
		} else {
			return 'headerColor1'; // Red color class
		}
	};

	const renderInsuranceCards = () => {
		if (scoreCardLoading) {
			return (
				<Skeleton
					active
					paragraph={{
						rows: 4,
					}}
				/>
			);
		}

		// Check if there are no insurance companies
		if (
			statisticsBucketData &&
			(!statisticsBucketData.insuranceCompanies ||
				statisticsBucketData.insuranceCompanies.length === 0)
		) {
			return (
				<Col xs={24}>
					<div style={{ textAlign: 'center', padding: '20px' }}>
						<strong style={{ color: 'rgba(0, 0, 0, 0.45)' }}>
							No Records Found
						</strong>
					</div>
				</Col>
			);
		}

		return (
			statisticsBucketData &&
			statisticsBucketData.insuranceCompanies &&
			statisticsBucketData.insuranceCompanies.map((company, index) => (
				<Col
					className="mobileScrollCard"
					key={index}
					xs={24}
					sm={12}
					md={12}
					lg={8}
					xl={6}
				>
					<XThemePayersCard className="mb-0 mt-3 mt-lg-0 mb-3">
						<Space>
							<img
								src={`${config.s3_url}${company.insuranceCompanyLogo?.url}`}
								alt={'icon here'}
								style={{ width: '52px', height: '52px' }}
							/>
							<div className="ms-1 d-block headerData">
								<span>Overall Score</span>
								<br />
								<em
									className={getScoreCardHeaderClassName(
										company.overallScore || 0,
									)}
								>
									{company.overallScore || 0}
								</em>
							</div>
						</Space>
						<Row className="mt-3">
							<Col xs={24}>
								<h6>{company.insuranceCompanyName}</h6>
							</Col>
						</Row>
						<Row>
							<Col xs={24}>
								<h6 className="overallScoreList2">
									% Timely Appeals Processing{' '}
									<Tooltip title="This is the percentage of cases that were processed on time.">
										<InfoCircleOutlined className="dashboard-tooltip-css" />
									</Tooltip>
									<span
										className={getScoreCardParameterClassName(
											company.timely_processing || 0,
											false,
										)}
									>
										{/* {company.timely_processing || 0}% */}
										{Math.round(
											company.timely_processing || 0,
										)}
										%
									</span>
								</h6>
								<h6 className="overallScoreList2">
									% Paid Timely{' '}
									<Tooltip title="This is the percentage of cases that were paid on time.">
										<InfoCircleOutlined className="dashboard-tooltip-css" />
									</Tooltip>
									<span
										className={getScoreCardParameterClassName(
											company.timely_paid || 0,
											false,
										)}
									>
										{/* {company.timely_paid || 0}% */}
										{Math.round(company.timely_paid || 0)}%
									</span>
								</h6>
								<h6 className="overallScoreList2">
									% Upheld{' '}
									<Tooltip title="This is the percentage of cases that were rejected and remain rejected after review.">
										<InfoCircleOutlined className="dashboard-tooltip-css" />
									</Tooltip>{' '}
									<span
										className={getScoreCardParameterClassName(
											company.upheldCountPercentage || 0,
											true,
										)}
									>
										{/* {company.upheldCountPercentage || 0}% */}
										{Math.round(
											company.upheldCountPercentage || 0,
										)}
										%
									</span>
								</h6>
								<h6 className="overallScoreList2">
									% Overturned{' '}
									<Tooltip title="This is the percentage of cases that were initially rejected but then approved at a later stage.">
										<InfoCircleOutlined className="dashboard-tooltip-css" />
									</Tooltip>{' '}
									<span
										className={getScoreCardParameterClassName(
											company.overturnedPercentage || 0,
											true,
										)}
									>
										{/* {company.overturnedPercentage || 0}% */}
										{Math.round(
											company.overturnedPercentage || 0,
										)}
										%
									</span>
								</h6>
								<h6 className="overallScoreList2">
									% Denied{' '}
									<Tooltip title="This is the percentage of cases that were rejected at any stage in the process, regardless of the final outcome.">
										<InfoCircleOutlined className="dashboard-tooltip-css" />
									</Tooltip>{' '}
									<span
										className={getScoreCardParameterClassName(
											company.rejectionPercentage || 0,
											true,
										)}
									>
										{/* {company.rejectionPercentage || 0}% */}
										{Math.round(
											company.rejectionPercentage || 0,
										)}
										%
									</span>
								</h6>
								<h6 className="overallScoreList2">
									Initial Denial %{' '}
									<Tooltip title="This is the percentage of cases that were rejected at the initial stage, known as the organization determination stage.">
										<InfoCircleOutlined className="dashboard-tooltip-css" />
									</Tooltip>{' '}
									<span
										className={getScoreCardParameterClassName(
											company.initialRejectionPercentage ||
												0,
											true,
										)}
									>
										{/* {company.initialRejectionPercentage ||
											0} */}
										{Math.round(
											company.initialRejectionPercentage ||
												0,
										)}
										%
									</span>
								</h6>
							</Col>
						</Row>
						<Row className="my-3">
							<Col xs={24}>
								<h5>Pending by Number of Cases</h5>
							</Col>
						</Row>
						<Row>
							<Col xs={24}>
								<h6 className="overallScoreList listColor2 mb-1">
									Pre-service{' '}
									<span>
										{company.revenueCycleCount
											.pre_service_count || 0}
									</span>
								</h6>
								<h6 className="overallScoreList listColor2 mb-1">
									Post Claim{' '}
									<span>
										{company.revenueCycleCount
											.post_claim_count || 0}
									</span>
								</h6>
								<h6 className="overallScoreList listColor2 mb-1">
									Part B Drugs{' '}
									<span>
										{company.revenueCycleCount
											.part_b_drugs_count || 0}
									</span>
								</h6>
							</Col>
						</Row>
						<Row className="my-3">
							<Col xs={24}>
								<h5>Pending by Dollar Value</h5>
							</Col>
						</Row>
						<Row>
							<Col xs={24}>
								<h6 className="overallScoreList listColor3 mb-1">
									Pre-service{' '}
									<span>
										$
										{formatNumber(
											company.revenueCycleAmount
												.pre_service_amount || 0,
										)}
									</span>
								</h6>
								<h6 className="overallScoreList listColor3 mb-1">
									Post Claim{' '}
									<span>
										$
										{formatNumber(
											company.revenueCycleAmount
												.post_claim_amount || 0,
										)}
									</span>
								</h6>
								<h6 className="overallScoreList listColor3 mb-1">
									Part B Drugs{' '}
									<span>
										$
										{formatNumber(
											company.revenueCycleAmount
												.part_b_drugs_amount || 0,
										)}
									</span>
								</h6>
							</Col>
						</Row>
					</XThemePayersCard>
				</Col>
			))
		);
	};

	useEffect(() => {
		if (getInsuranceCompaniesBucketState.apiState === 'loading') {
			setScoreCardLoading(true);
		}
		if (getInsuranceCompaniesBucketState.apiState === 'success') {
			setStatisticsBucketData(getInsuranceCompaniesBucketState.data);
			setScoreCardLoading(false);
		}
		if (getInsuranceCompaniesBucketState.apiState === 'error') {
			setScoreCardLoading(false);
		}
		getInsuranceCompaniesBucketReset();
	}, [getInsuranceCompaniesBucketState]);
	// Score End

	const statusData =
		statisticsFilters.status === 'open'
			? statisticsData.open_cases?.filingStatusPercentages || {}
			: statisticsData.close_cases || {};

	const amountData =
		statisticsFilters.status === 'open'
			? statisticsData.open_cases?.amount || {}
			: statisticsData.close_cases || {};

	const statusChartData =
		statisticsFilters.status === 'open'
			? [statusData.in_process, statusData.at_risk, statusData.untimely]
			: [
					statusData.approvedAndPaidCount,
					statusData.approvedAndNotPaidCount,
					statusData.rejectedCaseCount,
			  ];

	const amountChartData =
		statisticsFilters.status === 'open'
			? [amountData.in_process, amountData.at_risk, amountData.untimely]
			: [
					amountData.approvedAndPaid,
					amountData.approvedAndNotPaid,
					amountData.rejectedAmount,
			  ];

	const statusColors =
		statisticsFilters.status === 'open'
			? ['#00B2AA', '#ED982A', '#B3454B']
			: ['#00B2AA', '#ED982A', '#B3454B'];

	const amountColors = statusColors;

	// Add this function to handle card expansion
	const handleCardExpand = (companyId) => {
		setExpandedCards((prev) => {
			const newState = {
				...prev,
				[companyId]: !prev[companyId],
			};
			return newState;
		});
	};
	const formatDate = (date) => {
		const options = {
			weekday: 'long',
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		};
		return date.toLocaleDateString('en-US', options);
	};
	const today = new Date();

	const showDrawer = () => {
		setOpen(true);
		console.log('open', open);
	};
	const onClose = () => {
		setOpen(false);
	};

	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;

	return (
		<>
			<XThemeModalAnimation
				centered
				open={lottieModalOpen}
				onOk={() => setLottieModalOpen(false)}
				onCancel={() => setLottieModalOpen(false)}
				footer={false}
				maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
			>
				<XThemeLottieLoader className="mb-4">
					<XThemeLottie animationData={LoaderJson} loop={true} />
				</XThemeLottieLoader>

				<Card>
					<ul>
						<li className="active">
							<span>
								<img
									width="15px"
									src="images/loader-icon1.svg"
								/>
							</span>
							Analysing Clinical Summary
						</li>
						<li className="active">
							<span>
								<img
									width="15px"
									src="images/loader-icon2.svg"
								/>
							</span>
							Mapping ICD 10 Codes
						</li>
						<li className="active">
							<span>
								<img
									width="15px"
									src="images/loader-icon3.svg"
								/>
							</span>
							Mapping CPT Codes
						</li>
						<li className="active">
							<span>
								<img
									width="15px"
									src="images/loader-icon4.svg"
								/>
							</span>
							Checking Coverage Determination
						</li>
						<li className="active">
							<span>
								<img
									width="15px"
									src="images/loader-icon5.svg"
								/>
							</span>
							Checking for Missing Inclusions
						</li>
						<li className="inprocess">
							<span>
								<img
									width="15px"
									src="images/loader-icon6.svg"
								/>
							</span>
							Generating Results
						</li>
					</ul>
					<div class="laser"></div>
				</Card>
			</XThemeModalAnimation>

			<>
				<Col lg={24} xl={24} xs={0} md={0}>
					<Header
						subHeader={`${getGreeting()}`}
						headerTag={`${getUserName()}`}
					/>
				</Col>
				<Col lg={0} xl={0} xs={24} md={24}>
					<HeaderFile activeNav="dashboard" />
				</Col>
			</>

			{/* New Dashboard */}
			<XThemeContainer fluid>
				<Row gutter={[15, 15]} className="align-items-center mb-4">
					<Col
						xs={24}
						md={12}
						lg={12}
						xl={12}
						className="text-center text-md-start"
					>
						<XTheme2MainTitle className="mb-2">
							{getGreeting()} <span>{getUserName()}</span>
						</XTheme2MainTitle>
						<XTheme2Para1>
							Track your progress here. You almost reach a goal!
						</XTheme2Para1>
					</Col>
					{checkModulePermissions('case-management').authorized ||
					checkModulePermissions('case-closure').authorized ? (
						<Col
							xs={24}
							md={12}
							lg={12}
							xl={12}
							className="text-center text-md-end"
						>
							<Space>
								{checkModulePermissions('case-management')
									.authorized &&
									(isMobile ? (
										<XTheme2Button
											shape="circle"
											size="large"
											className="noBackground borderColor"
											onClick={() =>
												navigate('/case/add')
											}
											icon={<PlusOutlined />}
										/>
									) : (
										<>
											<Link to="/case/add">
												<XTheme2Button
													size="large"
													icon={<PlusOutlined />}
												>
													Create New Case
												</XTheme2Button>
											</Link>
											
										</>
									))}
							</Space>
						</Col>
					) : (
						<></>
					)}
				</Row>
				<Row gutter={[15, 15]} className="mb-3">
					<Col xs={24} sm={24} md={24} lg={24} xl={24}>
						<XTheme2InnerCard>
							<Row gutter={[15, 15]}>
								{checkModulePermissions(
									'dashboard',
								).sub_modules.includes('view-case-amount') ? (
									<>
										<Col
											xs={24}
											sm={12}
											md={8}
											lg={8}
											xl={8}
											className="mb-3 mb-sm-0"
										>
											{getPreCalculatedDataState.apiState ===
											'loading' ? (
												<div className="insideCard borderRight">
													<Skeleton
														active
														paragraph={{ rows: 2 }}
													/>
												</div>
											) : totalCases > 0 ? (
												<div className="insideCard borderRight">
													<div className="imgWrapper">
														<img
															className="img-fluid"
															src="images/total-case-new.svg"
															alt=""
														/>
													</div>
													<div className="textWrapper">
														<span className="title">
															{selectedChartOption ===
															'Total'
																? 'Total Cases'
																: selectedChartOption}
														</span>
														<span>
															<XTheme2DropdownStatus
																menu={{
																	items: [
																		{
																			key: 'total',
																			label: (
																				<a
																					onClick={() =>
																						setSelectedChartOption(
																							'Total',
																						)
																					}
																				>
																					Total
																					Cases
																				</a>
																			),
																		},
																		...(chartData?.labels?.map(
																			(
																				label,
																				index,
																			) => ({
																				key: index.toString(),
																				label: (
																					<a
																						onClick={() =>
																							setSelectedChartOption(
																								label,
																							)
																						}
																					>
																						{
																							label
																						}
																					</a>
																				),
																			}),
																		) ||
																			[]),
																	],
																}}
																placement="bottomLeft"
																arrow
																noStyle
															>
																<Button
																	noStyle
																	icon={
																		<CaretDownOutlined />
																	}
																/>
															</XTheme2DropdownStatus>
														</span>
														<div className="numberWrapper">
															{selectedChartOption ===
															'Total'
																? totalCases
																: chartData
																		?.datasets?.[0]
																		?.data?.[
																		chartData?.labels?.indexOf(
																			selectedChartOption,
																		)
																  ] || 0}
															{/* //TODO <sub>+12%</sub> */}
														</div>
													</div>
												</div>
											) : (
												<div className="subHeading mt-4">
													No cases assigned to you at
													the moment.
												</div>
											)}
										</Col>
										<Col
											xs={24}
											sm={12}
											md={8}
											lg={8}
											xl={8}
											className="mb-3 mb-md-0"
										>
											{getPreCalculatedDataState.apiState ===
											'loading' ? (
												<div className="insideCard borderRight">
													<Skeleton
														active
														paragraph={{ rows: 2 }}
													/>
												</div>
											) : (
												<div className="insideCard borderRight">
													<div className="imgWrapper">
														<img
															className="img-fluid"
															src="images/total-case-value.svg"
															alt=""
														/>
													</div>
													<div className="textWrapper">
														<span className="title">
															{selectedAmountOption ===
															'Total'
																? 'Total Case Value'
																: selectedAmountOption ===
																  'Approved'
																? 'Approved Case Amount'
																: selectedAmountOption ===
																  'Rejected'
																? 'Rejected Case Amount'
																: 'In Progress Case Amount'}
														</span>
														<span>
															<XTheme2DropdownStatus
																menu={{
																	items: [
																		{
																			key: 'total',
																			label: (
																				<a
																					onClick={() =>
																						setSelectedAmountOption(
																							'Total',
																						)
																					}
																				>
																					Total
																					Case
																					Value
																				</a>
																			),
																		},
																		{
																			key: 'approved',
																			label: (
																				<a
																					onClick={() =>
																						setSelectedAmountOption(
																							'Approved',
																						)
																					}
																				>
																					Approved
																					Amount
																				</a>
																			),
																		},
																		{
																			key: 'rejected',
																			label: (
																				<a
																					onClick={() =>
																						setSelectedAmountOption(
																							'Rejected',
																						)
																					}
																				>
																					Rejected
																					Amount
																				</a>
																			),
																		},
																		{
																			key: 'pending',
																			label: (
																				<a
																					onClick={() =>
																						setSelectedAmountOption(
																							'Pending',
																						)
																					}
																				>
																					In
																					Progress
																					Amount
																				</a>
																			),
																		},
																	],
																}}
																placement="bottomLeft"
																arrow
																noStyle
															>
																<Button
																	noStyle
																	icon={
																		<CaretDownOutlined />
																	}
																/>
															</XTheme2DropdownStatus>
														</span>
														<div className="numberWrapper">
															{selectedAmountOption ===
															'Total'
																? `$${formatNumber(
																		caseAmount.totalCaseAmount ||
																			0,
																  )}`
																: selectedAmountOption ===
																  'Approved'
																? `$${formatNumber(
																		caseAmount.approvedAmount ||
																			0,
																  )}`
																: selectedAmountOption ===
																  'Rejected'
																? `$${formatNumber(
																		caseAmount.rejectedAmount ||
																			0,
																  )}`
																: `$${formatNumber(
																		caseAmount.pendingAmount ||
																			0,
																  )}`}
															{/* //TODO <sub>+7%</sub> */}
														</div>
													</div>
												</div>
											)}
										</Col>
									</>
								) : (
									<></>
								)}
								{checkModulePermissions(
									'dashboard',
								).sub_modules.includes('view-reimbursement') ? (
									<Col xs={24} sm={24} md={8} lg={8} xl={8}>
										{getPreCalculatedDataState.apiState ===
										'loading' ? (
											<div className="insideCard">
												<Skeleton
													active
													paragraph={{ rows: 2 }}
												/>
											</div>
										) : (
											<div className="insideCard">
												<div className="imgWrapper">
													<img
														className="img-fluid"
														src="images/reimbursement-new.svg"
														alt=""
													/>
												</div>
												<div className="textWrapper">
													<span className="title">
														{selectedReimbursementOption ===
														'Total'
															? 'Approved Claims'
															: selectedReimbursementOption ===
															  'Reimbursed'
															? 'Reimbursed'
															: selectedReimbursementOption ===
															  'Pending'
															? 'Pending Reimbursements'
															: 'Pending Claims Interest'}
													</span>
													<span>
														<XTheme2DropdownStatus
															menu={{
																items: [
																	{
																		key: 'total',
																		label: (
																			<a
																				onClick={() =>
																					setSelectedReimbursementOption(
																						'Total',
																					)
																				}
																			>
																				Approved
																				Claims
																			</a>
																		),
																	},
																	{
																		key: 'reimbursed',
																		label: (
																			<a
																				onClick={() =>
																					setSelectedReimbursementOption(
																						'Reimbursed',
																					)
																				}
																			>
																				Reimbursed
																			</a>
																		),
																	},
																	{
																		key: 'pending',
																		label: (
																			<a
																				onClick={() =>
																					setSelectedReimbursementOption(
																						'Pending',
																					)
																				}
																			>
																				Pending
																				Reimbursements
																			</a>
																		),
																	},
																	{
																		key: 'interest',
																		label: (
																			<a
																				onClick={() =>
																					setSelectedReimbursementOption(
																						'Interest',
																					)
																				}
																			>
																				Pending
																				Claims
																				Interest
																			</a>
																		),
																	},
																],
															}}
															placement="bottomLeft"
															arrow
															noStyle
														>
															<Button
																noStyle
																icon={
																	<CaretDownOutlined />
																}
															/>
														</XTheme2DropdownStatus>
													</span>
													<div className="numberWrapper">
														{selectedReimbursementOption ===
														'Total'
															? `$${formatNumber(
																	caseAmount.totalClaimAmount ||
																		0,
															  )}`
															: selectedReimbursementOption ===
															  'Reimbursed'
															? `$${formatNumber(
																	caseAmount.approvedClaimAmountMatchingDates ||
																		0,
															  )}`
															: selectedReimbursementOption ===
															  'Pending'
															? `$${formatNumber(
																	caseAmount.approvedClaimAmountReimbursedNull ||
																		0,
															  )}`
															: `$${formatNumber(
																	caseAmount.totalInterestAmount ||
																		0,
															  )}`}
														{/* //TODO <sub>+7%</sub> */}
													</div>
												</div>
											</div>
										)}
									</Col>
								) : (
									<></>
								)}
							</Row>
						</XTheme2InnerCard>
					</Col>
					{/* //TODO: later this */}
					{/* <Col xs={24} sm={24} md={24} lg={24} xl={6}>
						<XTheme2InnerCard>
							<div className="avatarTextWrapper">
								<div className="avatarImg">
									<XTheme2Badge dot>
										<Avatar
											size={60}
											icon={
												<img src="https://dev-s3-decodex.s3.amazonaws.com/users/67762c5b99aef55d21c62acc/appflavor.decodex-upload-1745850011563_4126.jpeg" />
											}
										/>
									</XTheme2Badge>
								</div>
								<div className="avatarText">
									Tabish Sangrar
									<br />
									<span>Super Admin</span>
								</div>
							</div>
							<div className="avatarTexDropDown">
								<Dropdown
									menu={{ items }}
									trigger={['click']}
									placement="bottomLeft"
									arrow={{ pointAtCenter: true }}
								>
									<a onClick={(e) => e.preventDefault()}>
										<Button
											shape="circle"
											size="large"
											icon={<MoreOutlined />}
										/>
									</a>
								</Dropdown>
							</div>
						</XTheme2InnerCard>
					</Col> */}
				</Row>
				{/* //TODO: VA this */}
				<Row gutter={[15, 15]} className="mb-4">
					<Col xs={24} sm={24} md={24} lg={12} xl={12}>
						<XTheme2Card className="gradientCard text-center h-100 d-flex flex-column justify-content-end">
							{/* <img
								src="images/animations-image.png"
								className="mt-4 img-fluid"
							/> */}
							<XThemeDashboardLottieCard
								animationData={DashboardJson}
								loop={true}
							/>
							<XTheme2MainTitle className="style1 mt-5 mb-2">
								How can I assist you today?
							</XTheme2MainTitle>
							<XTheme2ChatBox className="mt-4">
								<AIInput
									onSubmit={(message) => {
										// Navigate to VoiceAssistance with message in state
										navigate('/agent-maxx', {
											state: {
												dashboardMessage: message,
												fromDashboard: true,
											},
										});
									}}
								/>
							</XTheme2ChatBox>
						</XTheme2Card>
					</Col>
					<Col xs={24} sm={24} md={24} lg={12} xl={12}>
						<XTheme2Card title="Insights & Alerts">
							<XTheme2ListCard
								dataSource={[
									{
										title: `${dashboardCounts.at_risk_count.toString()} At-Risk Cases`,
										value: `${formatNumber(
											dashboardCounts.at_risk_amount,
										)}`,
										description: `Review cases flagged for escalation.`,
										color: 'color1',
									},
									{
										title: `${dashboardCounts.rejected_count.toString()} Rejected Claims`,
										value: `${formatNumber(
											dashboardCounts.rejected_amount,
										)}`,
										description: `Claims rejected. Needs follow-up.`,
										color: 'color2',
									},
									{
										title: `${dashboardCounts.pending_count.toString()} Pending Cases`,
										value: `${formatNumber(
											dashboardCounts.pending_amount,
										)}`,
										description: `Cases pending review for the action.`,
										color: 'color3',
									},
								]}
								renderItem={(item, index) => (
									<XTheme2ListCard.Item>
										<XTheme2ListCard.Item.Meta
											avatar={
												<XTheme2AvatarListCard
													className={item.color}
												>
													$
													<Counter
														end={parseInt(
															item.value,
														)}
														duration={1000}
													/>
												</XTheme2AvatarListCard>
											}
											title={item.title}
											description={item.description}
										/>
										<div className="buttonWrapper mt-2">
											{item.color === 'color1' && (
												<XTheme2ListBtn
													size="large"
													className="color1"
													onClick={() =>
														navigate(
															'/case-filing-management?filing_status=at_risk',
														)
													}
												>
													See List
												</XTheme2ListBtn>
											)}
											{item.color === 'color2' && (
												<XTheme2ListBtn
													size="large"
													className="color2"
													onClick={() =>
														navigate(
															'/case-filing-management?status=rejected',
														)
													}
												>
													Follow Up
												</XTheme2ListBtn>
											)}
											{item.color === 'color3' && (
												<XTheme2ListBtn
													size="large"
													className="color3"
													onClick={() =>
														navigate(
															'/case-filing-management?status=pending',
														)
													}
												>
													View List
												</XTheme2ListBtn>
											)}
										</div>
									</XTheme2ListCard.Item>
								)}
							/>
						</XTheme2Card>
					</Col>
				</Row>
				{/* Insurance Payer */}
				{checkModulePermissions('dashboard').sub_modules.includes(
					'view-insurance-table',
				) ? (
					<>
						<Row
							gutter={[15, 15]}
							className="mb-3 align-items-center"
						>
							<Col xs={24} sm={24} md={6} lg={6} xl={6}>
								<XTheme2MainTitle className="style1">
									Insurance Payer{' '}
									<Tooltip title="View detailed information about insurance payers and their performance metrics">
										<InfoCircleOutlined />
									</Tooltip>
								</XTheme2MainTitle>
							</Col>
							<Col
								xs={24}
								sm={24}
								md={18}
								lg={18}
								xl={18}
								className="text-md-end"
							>
								<XTheme2InsuranceSpace>
									{/* Keep the new UI segmented button */}
									<XTheme2Segmented
										value={tableFilters.status}
										onChange={(value) =>
											handleTableFilterChange({
												status: value,
											})
										}
										options={[
											{
												value: 'open',
												label: 'Open Cases',
											},
											{
												value: 'closed',
												label: 'Closed Cases',
											},
										]}
									/>
									<XTheme2Form.Item className="mb-0">
										<XTheme2CustomSelect
											size="small"
											placeholder="Insurance Provider"
											value={
												tableFilters.insuranceCompany
											}
											onChange={(value) =>
												handleTableFilterChange({
													insuranceCompany: value,
												})
											}
											onFocus={() =>
												getInsuranceDropdown()
											}
											onSearch={(search) => {
												if (search.length >= 3) {
													getInsuranceDropdown({
														search,
													});
												} else if (
													search.length === 0
												) {
													getInsuranceDropdown();
												}
											}}
											allowClear
											filterOption={filterByLabel}
											options={
												getInsuranceDropdownState.apiState ===
													'success' &&
												getInsuranceDropdownState.data
													?.length > 0 &&
												getInsuranceDropdownState.data.map(
													(itm) => ({
														label: itm.name,
														value: itm._id,
													}),
												)
											}
										/>
									</XTheme2Form.Item>
									<XTheme2Form.Item className="mb-0">
										<XTheme2CustomSelect
											className="customColor"
											defaultValue="Weekly"
											size="small"
											placeholder="Select"
											value={activeTableTimeFilter}
											onChange={(value) =>
												handleTableTimeFilterClick(
													value,
												)
											}
											options={[
												{
													value: 'last_week',
													label: 'Weekly',
												},
												{
													value: 'last_month',
													label: 'Monthly',
												},
												{
													value: 'year_to_date',
													label: 'Year to Date',
												},
											]}
										/>
									</XTheme2Form.Item>
									<DatePicker.RangePicker
										size="small"
										value={tableDateRange}
										className="dashboard-picker"
										disabledDate={(current) =>
											current &&
											current > moment().endOf('day')
										}
										onChange={handleTableDateRangeChange}
									/>
									{tableFiltersApplied && (
										<XTheme2Button
											size="small"
											onClick={handleTableClearFilters}
										>
											Clear Filters
										</XTheme2Button>
									)}
								</XTheme2InsuranceSpace>
							</Col>
						</Row>

						{/* Dynamic Insurance Payer Cards */}
						{statisticsTableData?.insuranceCompanies?.map(
							(company, index) => (
								<XTheme2InsurancePayerCard
									key={index}
									className={
										index <
										statisticsTableData.insuranceCompanies
											.length -
											1
											? 'mb-2'
											: ''
									}
								>
									<Row
										gutter={[15, 15]}
										className="align-items-center"
									>
										<Col xs={4} sm={2} md={2} lg={1}>
											<div className="payerLogo">
												<img
													className="img-fluid"
													src={`${config.s3_url}${company.insuranceCompanyLogo?.url}`}
													alt={'Logo'}
												/>
											</div>
										</Col>
										<Col
											xs={20}
											sm={10}
											md={10}
											lg={8}
											className="payerBorder"
										>
											<div className="payerName">
												{company.insuranceCompanyName}
											</div>
										</Col>
										<Col
											xs={12}
											sm={6}
											md={6}
											lg={3}
											className="text-center payerBorder"
										>
											<div className="payerName">
												Rejected{' '}
												<span>
													{company.rejectedPercentage ||
														0}
													%
												</span>
											</div>
										</Col>
										<Col
											xs={12}
											sm={6}
											md={6}
											lg={3}
											className="text-center payerBorder"
										>
											<div className="payerName">
												Overturned{' '}
												<span>
													{company.overturnedPercentage ||
														0}
													%
												</span>
											</div>
										</Col>
										<Col
											xs={12}
											sm={8}
											md={8}
											lg={3}
											className="text-center"
										>
											<div className="tagStatus">
												<span className="color1">
													&nbsp;
												</span>
												<em className="color1">
													{company.filingStatusCounts
														.in_process || 0}
												</em>{' '}
												In Process
											</div>
										</Col>
										<Col
											xs={12}
											sm={8}
											md={8}
											lg={3}
											className="text-center"
										>
											<div className="tagStatus">
												<span className="color2">
													&nbsp;
												</span>
												<em className="color2">
													{company.filingStatusCounts
														.at_risk || 0}
												</em>{' '}
												At-Risk
											</div>
										</Col>
										<Col
											xs={12}
											sm={8}
											md={8}
											lg={3}
											className="text-center"
										>
											<div className="tagStatus">
												<span className="color3">
													&nbsp;
												</span>
												<em className="color3">
													{company.filingStatusCounts
														.untimely || 0}
												</em>{' '}
												Untimely
											</div>
										</Col>
									</Row>
								</XTheme2InsurancePayerCard>
							),
						)}

						{insuranceTableLoading && (
							<div className="text-center p-4">
								<Skeleton active paragraph={{ rows: 4 }} />
							</div>
						)}

						{!insuranceTableLoading &&
							(!statisticsTableData?.insuranceCompanies ||
								statisticsTableData.insuranceCompanies
									.length === 0) && (
								<div className="text-center p-4">
									<strong
										style={{ color: 'rgba(0, 0, 0, 0.45)' }}
									>
										No Records Found
									</strong>
								</div>
							)}
					</>
				) : (
					<></>
				)}

				{/* Payers Score Card */}
				{checkModulePermissions('dashboard').sub_modules.includes(
					'view-payer-score-card',
				) ? (
					<>
						<Row gutter={[15, 15]} className="mt-4 mb-3">
							<Col xs={24} sm={24} md={8} lg={8} xl={8}>
								<XTheme2MainTitle className="style1">
									Payers Score Card{' '}
									<Tooltip title="View detailed performance metrics for each insurance payer">
										<InfoCircleOutlined />
									</Tooltip>
								</XTheme2MainTitle>
							</Col>
							<Col
								xs={24}
								sm={24}
								md={16}
								lg={16}
								xl={16}
								className="text-md-end"
							>
								<XTheme2InsuranceSpace>
									<XTheme2Form.Item className="mb-0">
										<XTheme2CustomSelect
											size="small"
											placeholder="Insurance Provider"
											value={
												scoreFilters.insuranceCompany
											}
											onChange={(value) =>
												handleScoreFilterChange({
													insuranceCompany: value,
												})
											}
											onFocus={() =>
												getInsuranceDropdown()
											}
											onSearch={(search) => {
												if (search.length >= 3) {
													getInsuranceDropdown({
														search,
													});
												} else if (
													search.length === 0
												) {
													getInsuranceDropdown();
												}
											}}
											allowClear
											filterOption={filterByLabel}
											options={
												getInsuranceDropdownState.apiState ===
													'success' &&
												getInsuranceDropdownState.data
													?.length > 0 &&
												getInsuranceDropdownState.data.map(
													(itm) => ({
														label: itm.name,
														value: itm._id,
													}),
												)
											}
										/>
									</XTheme2Form.Item>
									<XTheme2Form.Item className="mb-0">
										<XTheme2CustomSelect
											className="customColor"
											size="small"
											placeholder="Select Time Period"
											value={activeScoreTimeFilter}
											onChange={(value) =>
												handleScoreTimeFilterClick(
													value,
												)
											}
											options={[
												{
													value: 'last_week',
													label: 'Weekly',
												},
												{
													value: 'last_month',
													label: 'Monthly',
												},
												{
													value: 'year_to_date',
													label: 'Year to Date',
												},
											]}
										/>
									</XTheme2Form.Item>
									<DatePicker.RangePicker
										size="small"
										value={scoreDateRange}
										className="dashboard-picker"
										disabledDate={(current) =>
											current &&
											current > moment().endOf('day')
										}
										onChange={handleScoreDateRangeChange}
									/>
									{scoreFiltersApplied && (
										<XTheme2Button
											size="small"
											onClick={handleScoreClearFilters}
										>
											Clear Filters
										</XTheme2Button>
									)}
								</XTheme2InsuranceSpace>
							</Col>
						</Row>

						<Row gutter={[15, 15]}>
							{scoreCardLoading ? (
								<Col xs={24}>
									<Skeleton active paragraph={{ rows: 4 }} />
								</Col>
							) : statisticsBucketData?.insuranceCompanies
									?.length > 0 ? (
								statisticsBucketData.insuranceCompanies.map(
									(company, index) => (
										<Col
											key={index}
											xs={24}
											sm={12}
											md={12}
											lg={6}
											xl={6}
											className="text-center"
										>
											<XTheme2Card
												className="noPadding"
												style={{
													height: 'auto', // Add this
													display: 'flex', // Add this
													flexDirection: 'column', // Add this
												}}
											>
												<div className="payerLogo">
													<div className="imageWrapper">
														<img
															className="img-fluid"
															src={`${config.s3_url}${company.insuranceCompanyLogo?.url}`}
															alt={
																company.insuranceCompanyName
															}
															style={{
																maxWidth:
																	'40px',
																maxHeight:
																	'40px',
																objectFit:
																	'contain',
															}}
														/>
													</div>
													<div className="payerName my-3">
														{
															company.insuranceCompanyName
														}
													</div>
												</div>
												<XTheme2Progress
													type="dashboard"
													size={150}
													percent={
														company.overallScore ||
														0
													}
													strokeColor={{
														'0%': '#067EF1',
														'100%': '#0E4C88',
													}}
													trailColor="#E9ECF1"
													strokeLinecap="round"
													format={() => (
														<div className="subHeading">
															<div className="percentValue">
																{company.overallScore ||
																	0}
																%
															</div>
															<div className="subHeadingText">
																Overall Score
															</div>
														</div>
													)}
												/>
												<div className="w-100 text-center">
													<XTheme2TextButton
														onClick={() =>
															handleCardExpand(
																company.insuranceCompany,
															)
														}
													>
														{expandedCards[
															company
																.insuranceCompany
														]
															? 'Hide Details'
															: 'View Full Score'}
													</XTheme2TextButton>
												</div>

												{expandedCards[
													company.insuranceCompany
												] && (
													<div style={{ flex: 1 }}>
														{' '}
														{/* Add this wrapper */}
														<Divider
															dashed
															className="my-2"
														/>
														<div className="hasPadding">
															<div>
																<Row>
																	<Col
																		xs={24}
																	>
																		<XTheme2ViewMoreListCard>
																			%
																			Timely
																			Appeals
																			Processing
																			<Tooltip title="This is the percentage of cases that were processed on time.">
																				<InfoCircleOutlined className="dashboard-tooltip-css" />
																			</Tooltip>
																			<div
																				className={`fixedMoreValue ${getScoreCardParameterClassName(
																					company.timely_processing ||
																						0,
																					false,
																				)}`}
																			>
																				{company.timely_processing ||
																					0}

																				%
																			</div>
																		</XTheme2ViewMoreListCard>
																		<XTheme2ViewMoreListCard>
																			%
																			Paid
																			Timely{' '}
																			<Tooltip title="This is the percentage of cases that were paid on time.">
																				<InfoCircleOutlined className="dashboard-tooltip-css" />
																			</Tooltip>
																			<div
																				className={`fixedMoreValue ${getScoreCardParameterClassName(
																					company.timely_paid ||
																						0,
																					false,
																				)}`}
																			>
																				{company.timely_paid ||
																					0}

																				%
																			</div>
																		</XTheme2ViewMoreListCard>
																		<XTheme2ViewMoreListCard>
																			%
																			Upheld{' '}
																			<Tooltip title="This is the percentage of cases that were rejected and remain rejected after review.">
																				<InfoCircleOutlined className="dashboard-tooltip-css" />
																			</Tooltip>
																			<div
																				className={`fixedMoreValue ${getScoreCardParameterClassName(
																					company.upheldCountPercentage ||
																						0,
																					true,
																				)}`}
																			>
																				{company.upheldCountPercentage ||
																					0}

																				%
																			</div>
																		</XTheme2ViewMoreListCard>
																		<XTheme2ViewMoreListCard>
																			%
																			Overturned{' '}
																			<Tooltip title="This is the percentage of cases that were initially rejected but then approved at a later stage.">
																				<InfoCircleOutlined className="dashboard-tooltip-css" />
																			</Tooltip>
																			<div
																				className={`fixedMoreValue ${getScoreCardParameterClassName(
																					company.overturnedPercentage ||
																						0,
																					true,
																				)}`}
																			>
																				{company.overturnedPercentage ||
																					0}

																				%
																			</div>
																		</XTheme2ViewMoreListCard>
																		<XTheme2ViewMoreListCard>
																			%
																			Denied{' '}
																			<Tooltip title="This is the percentage of cases that were rejected at any stage in the process, regardless of the final outcome.">
																				<InfoCircleOutlined className="dashboard-tooltip-css" />
																			</Tooltip>
																			<div
																				className={`fixedMoreValue ${getScoreCardParameterClassName(
																					company.rejectionPercentage ||
																						0,
																					true,
																				)}`}
																			>
																				{company.rejectionPercentage ||
																					0}

																				%
																			</div>
																		</XTheme2ViewMoreListCard>
																		<XTheme2ViewMoreListCard>
																			Initial
																			Denial
																			%{' '}
																			<Tooltip title="This is the percentage of cases that were rejected at the initial stage, known as the organization determination stage.">
																				<InfoCircleOutlined className="dashboard-tooltip-css" />
																			</Tooltip>
																			<div
																				className={`fixedMoreValue ${getScoreCardParameterClassName(
																					company.initialRejectionPercentage ||
																						0,
																					true,
																				)}`}
																			>
																				{company.initialRejectionPercentage ||
																					0}

																				%
																			</div>
																		</XTheme2ViewMoreListCard>
																	</Col>
																</Row>
																<Row className="my-3">
																	<Col
																		xs={24}
																	>
																		<XTheme2ViewMoreTitle>
																			Pending
																			Cases
																		</XTheme2ViewMoreTitle>
																	</Col>
																</Row>
																<Row>
																	<Col
																		xs={24}
																	>
																		<XTheme2ViewMorePending>
																			<ul>
																				<li className="listColor2">
																					<em>
																						{company
																							.revenueCycleCount
																							?.pre_service_count ||
																							0}
																					</em>
																					Pre-service{' '}
																					<span>
																						$
																						{formatNumber(
																							company
																								.revenueCycleAmount
																								?.pre_service_amount ||
																								0,
																						)}
																					</span>
																				</li>
																				<li className="listColor2">
																					<em>
																						{company
																							.revenueCycleCount
																							?.post_claim_count ||
																							0}
																					</em>
																					Post
																					Claim{' '}
																					<span>
																						$
																						{formatNumber(
																							company
																								.revenueCycleAmount
																								?.post_claim_amount ||
																								0,
																						)}
																					</span>
																				</li>
																				<li className="listColor2">
																					<em>
																						{company
																							.revenueCycleCount
																							?.part_b_drugs_count ||
																							0}
																					</em>
																					Part
																					B
																					Drugs{' '}
																					<span>
																						$
																						{formatNumber(
																							company
																								.revenueCycleAmount
																								?.part_b_drugs_amount ||
																								0,
																						)}
																					</span>
																				</li>
																			</ul>
																		</XTheme2ViewMorePending>
																	</Col>
																</Row>
															</div>
														</div>
													</div>
												)}
											</XTheme2Card>
										</Col>
									),
								)
							) : (
								<Col xs={24}>
									<div className="text-center p-4">
										<strong
											style={{
												color: 'rgba(0, 0, 0, 0.45)',
											}}
										>
											No Records Found
										</strong>
									</div>
								</Col>
							)}
						</Row>
					</>
				) : null}
			</XThemeContainer>
		</>
	);
};

const mapStateToProps = (state) => ({
	getCaseChartDetailsState: state.getCaseChartDetails,
	getTotalCaseAmountState: state.getTotalCaseAmount,
	getInsuranceCompaniesStatisticsState: state.getInsuranceCompaniesStatistics,
	getInsuranceCompaniesFilingStatusCountsState:
		state.getInsuranceCompaniesFilingStatusCounts,
	getInsuranceCompaniesBucketState: state.getInsuranceCompaniesBucket,
	getInsuranceDropdownState: state.getInsuranceDropdown,
	getCaseAmountBucketState: state.getCaseAmountBucket,
	getPreCalculatedDataState: state.getPreCalculatedData,
	getCountByFilingAndRevenueState: state.getCountByFilingAndRevenue,
});

const mapDispatchToProps = (dispatch) => ({
	getCaseChartDetails: () => dispatch(getCaseChartDetailsApi()),
	getTotalCaseAmount: () => dispatch(getTotalCaseAmountApi()),
	getCaseChartDetailsReset: () => dispatch(getCaseChartDetailsReset()),
	getTotalCaseAmountReset: () => dispatch(getTotalCaseAmountReset()),
	getInsuranceCompaniesStatistics: (data) =>
		dispatch(getInsuranceCompaniesStatisticsApi(data)),
	getInsuranceCompaniesStatisticsReset: (data) =>
		dispatch(getInsuranceCompaniesStatisticsReset(data)),
	getInsuranceCompaniesFilingStatusCounts: (data) =>
		dispatch(getInsuranceCompaniesFilingStatusCountsApi(data)),
	getInsuranceCompaniesFilingStatusCountsReset: (data) =>
		dispatch(getInsuranceCompaniesFilingStatusCountsReset(data)),
	getInsuranceCompaniesBucket: (data) =>
		dispatch(getInsuranceCompaniesBucketApi(data)),
	getInsuranceCompaniesBucketReset: (data) =>
		dispatch(getInsuranceCompaniesBucketReset(data)),
	getInsuranceDropdown: (params) => dispatch(getInsuranceDropdownApi(params)),
	getCaseAmountBucket: (params) => dispatch(getCaseAmountBucketApi(params)),
	getCaseAmountBucketReset: (params) =>
		dispatch(getCaseAmountBucketReset(params)),
	getInsuranceDropdownReset: () => dispatch(getInsuranceDropdownReset()),
	getPreCalculatedData: (params) => dispatch(getPreCalculatedDataApi(params)),
	getPreCalculatedDataReset: () => dispatch(getPreCalculatedDataReset()),
	getCountByFilingAndRevenue: () => dispatch(getCountByFilingAndRevenueApi()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
